import React from "react"
import "./heading.scss"
import {useNavigate} from "react-router";
import {BackIcon} from "../../../../assets/icons/defaultIcons";

export default function Heading(options) {
    const navigate = useNavigate()

    return(
        <div className={`heading ${options.className && options.className}`} style={{margin:options.margin}}>
            <h3 style={{margin:options.marginHeading}}>
                {options.back &&
                (<span className={'back'} onClick={()=>{navigate(-1)}} >
                    <BackIcon />
                </span>)
                }
                {options.heading}
            </h3>
        </div>
    )
}